// extracted by mini-css-extract-plugin
export default {"root":"CodeLanguageToggle_root__qSqW6"};